import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { RegistroCiudadanoUACCOMPONENT } from './registro-ciudadano-UAC.component';

const routes: Routes = [
    
    { path: '', component: RegistroCiudadanoUACCOMPONENT }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class RegistroCiudadanoUACRouting { }